import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { CHILDREN_PROP_TYPES } from 'propTypes';
import { ONLINE_ORDERING_BASE_PATH } from 'bento-ordering/base/constants/basePaths';
import PageLoadSpinner from 'components/PageLoadSpinner';
import { setupInitialFlow } from 'bento-ordering/base/actions/setupInitialFlow';
import GroupOrderNotFoundError from 'bento-ordering/group_ordering/errors/GroupOrderNotFoundError';

export const SetupInitialFlow = ({ children, dispatch }) => {
  const [readyToRender, setReadyToRender] = useState(false);

  useEffect(() => {
    const asyncFn = async () => {
      try {
        await dispatch(setupInitialFlow({}));
        setReadyToRender(true);
      } catch (error) {
        if (error instanceof GroupOrderNotFoundError) {
          window.location.replace(`${ONLINE_ORDERING_BASE_PATH}`);
        }
      }
    };
    asyncFn();
    // prevents memory leak
    return () => {};
  }, [dispatch]);
  return readyToRender ? children : <PageLoadSpinner />;
};

SetupInitialFlow.propTypes = {
  children: CHILDREN_PROP_TYPES,
  dispatch: PropTypes.func.isRequired
};

export default connect()(SetupInitialFlow);
